import { url } from "@/config";

import axios from "axios";
import qs from "qs";
import { storage } from "@/utils";
import { Message } from "element-ui";

const service = axios.create({
  baseURL: url + "/api",
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
});

service.interceptors.request.use(
  (config) => {
    const contentTypeHeader = config.headers["Content-Type"] || "";
    if (
      (config.method === "post" || config.method === "put") &&
      contentTypeHeader.indexOf("application/x-www-form-urlencoded") !== -1
    ) {
      config.data = qs.stringify(config.data, { allowDots: true });
    }

    let token = storage.get("token") || "";
    if (token) {
      config.headers["Authorization"] = token;
    }

    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;

    return res;
  },
  (error) => {
    const { status, data } = error.response;
    if (status >= 400 && status < 500) {
      const { msg = "" } = data;
      Message({
        message: msg,
        type: "warning"
      });
    }

    return Promise.reject(error.response);
  }
);

export { service as request };
